import React from "react";
import { ButtonBase, Tooltip, Typography } from "@mui/material";

export default function SecondaryTabGroup({
  tabs = [
    { value: "used", label: "Used" },
    { value: "new", label: "New" },
  ],
  onClick,
  active,
  customLabel = false,
  customValue = false,
  disabled = false,
}) {
  return (
    <div
      className={`switch_tab mr-[20px] mb-[15px] inline-block ${
        disabled ? "opacity-40" : "opacity-100"
      }`}
    >
      <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex flex-wrap">
        {tabs.map((item, index) => {
          return (
            <ButtonBase
              key={item.id}
              disableTouchRipple={item?.disabled || disabled}
              disabled={item?.disabled ? true : false}
            >
              <span
                className={`switch ${active === item.id && "active"} ${
                  item?.disabled ? "opacity-40" : ""
                }`}
                onClick={
                  disabled || item.disabled
                    ? () => {}
                    : () => onClick(item.id, index)
                }
              >
                {item.name}
              </span>
            </ButtonBase>
          );
        })}
      </div>
    </div>
  );
}
